/**
 * formats a number to show a given number of decimal places
 * @param num number to be formatted
 * @param decimalPlaces number of decimal which is going to be shown
 * in the formatted number
 */
export function formatToDecimalPlaces(num, decimalPlaces) {
  const round = 10 ** decimalPlaces;
  return (Math.round(num * round) / round)
    .toFixed(decimalPlaces)
    .replace('.', ',');
}

/**
 * Trunca um número para N casas decimais mantendo sua precisão
 * @param {*} num 
 * @param {*} decimalPlaces 
 * @returns 
 */
export function formatToDecimalPlacesReturningNumber(num, decimalPlaces = 2) {
  const valorNumerico = Number(num);

  const entradaInvalida = !Number.isFinite(valorNumerico);
  const casasDecimaisInvalidas = typeof decimalPlaces !== "number" || !Number.isInteger(decimalPlaces);

  if (entradaInvalida || casasDecimaisInvalidas) {
    return NaN;
  }

  if (Number.isInteger(valorNumerico)) {
    return valorNumerico;
  }

  const fator = 10 ** decimalPlaces;
  return Math.trunc(valorNumerico * fator) / fator;
}